import { render, staticRenderFns } from "./shopPage.vue?vue&type=template&id=c90d4834&scoped=true"
import script from "./shopPage.vue?vue&type=script&lang=js"
export * from "./shopPage.vue?vue&type=script&lang=js"
import style0 from "./shopPage.vue?vue&type=style&index=0&id=c90d4834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90d4834",
  null
  
)

export default component.exports